import { render } from "./WorkTemplates.vue?vue&type=template&id=721613c3&scoped=true"
import script from "./WorkTemplates.vue?vue&type=script&lang=js"
export * from "./WorkTemplates.vue?vue&type=script&lang=js"

import "./WorkTemplates.vue?vue&type=style&index=0&id=721613c3&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721613c3"]])

export default __exports__